import { VIBES } from '../data/quizData';

export const encodeQuizData = (name, answers) => {
  try {
    const data = { n: name, a: answers };
    const jsonString = JSON.stringify(data);
    const utf8Bytes = new TextEncoder().encode(jsonString);
    let binString = "";
    for (let i = 0; i < utf8Bytes.length; i++) {
      binString += String.fromCharCode(utf8Bytes[i]);
    }
    const base64 = btoa(binString)
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '');
    return base64;
  } catch (e) {
    console.error("Encoding error:", e);
    return null;
  }
};

export const decodeQuizData = (encodedString) => {
  try {
    let base64 = encodedString.replace(/-/g, '+').replace(/_/g, '/');
    while (base64.length % 4) { base64 += '='; }
    const binString = atob(base64);
    const utf8Bytes = new Uint8Array(binString.length);
    for (let i = 0; i < binString.length; i++) {
      utf8Bytes[i] = binString.charCodeAt(i);
    }
    const jsonString = new TextDecoder().decode(utf8Bytes);
    const parsed = JSON.parse(jsonString);
    return { name: parsed.n, answers: parsed.a };
  } catch (e) {
    console.error("Decoding error:", e);
    return null;
  }
};

export const calculateVibe = (answers) => {
  if (!answers || answers.length === 0) return VIBES[0];
  const counts = [0, 0, 0, 0];
  answers.forEach(val => {
    if (val >= 0 && val <= 3) counts[val]++;
  });
  const maxIndex = counts.indexOf(Math.max(...counts));
  return VIBES[maxIndex];
};

export const calculateScore = (originalAnswers, friendAnswers) => {
  let score = 0;
  const len = Math.min(originalAnswers.length, friendAnswers.length);
  for (let i = 0; i < len; i++) {
    if (originalAnswers[i] === friendAnswers[i]) {
      score++;
    }
  }
  return score;
};